<style lang="scss" scoped>
@import "core";
.dn-spinner {
  display: inline-block;
}
</style>



<template>
  <dn-circle2
    class="dn-spinner"
    :size="computedSize"
    :color="color"
    :background="background"
  />
</template>



<script>



export default {
  props: {
    size: {
      type: [String, Number],
      default: 50,
    },
    color: {
      type: String,
      default: '#0aa0d7',
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0.25)',
    },
  },



  computed: {
    computedSize() { return (typeof this.size === 'string' ? this.size.replace('px', '') + 'px' : this.size + 'px') },
  },
}
</script>


// WEBPACK FOOTER //
// Spinner.vue?156c698b